export enum STEP {
  HELP_CENTER_ARTICLE = "HELP_CENTER_ARTICLE",
  CONFIRMATION = "CONFIRMATION",
  LOGGED_OUT_CONTACT_US = "LOGGED_OUT_CONTACT_US",
  LOGGED_OUT_SELECT_TOPIC = "LOGGED_OUT_SELECT_TOPIC",
}

export enum EVENT {
  LOGIN_MODAL_PAGE = "LOGIN_MODAL_PAGE",
  HOW_CAN_WE_HELP_PAGE = "HOW_CAN_WE_HELP_PAGE",
  DOES_THIS_HELP_PAGE = "DOES_THIS_HELP_PAGE",
  CONTACT_US_PAGE = "CONTACT_US_PAGE",
  CONFIRMATION_PAGE = "CONFIRMATION_PAGE",
}

export const validateEmail = (email: string) => {
  return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
    String(email).toLowerCase()
  );
};
